import React, { createContext, useContext, useEffect, useState } from 'react';
import { Auth, Hub } from 'aws-amplify';

const SessionContext = createContext(null);

export const useSession = () => useContext(SessionContext);

export const SessionProvider = ({ children }) => {
  const [session, setSession] = useState({ token: null, loading: true });

  useEffect(() => {
    const fetchSession = async () => {
      try {
        const currentSession = await Auth.currentSession();
        const idToken = currentSession.getIdToken().getJwtToken();
        setSession({ token: idToken, loading: false });
      } catch (error) {
        setSession({ token: null, loading: false });
      }
    };

    fetchSession();

    const handleAuth = data => {
      if (data.payload.event === 'signIn') {
        fetchSession();
      } else if (data.payload.event === 'signOut') {
        setSession({ token: null, loading: false });
      }
    };

    const listener = Hub.listen('auth', handleAuth);

    return () => {
      listener();
    };
  }, []);

  return <SessionContext.Provider value={session}>{children}</SessionContext.Provider>;
};
